import 'arrive';
import Swiper from 'swiper/bundle';

document.arrive('.block-latest-news', { existing: true }, function (el) {
  const container = el.querySelector('.block-latest-news__grid.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  // Mark as initialized to avoid duplicates
  container.dataset.swiperInitialized = 'true';

  // On mobile, turn grid into slider with 1.2 slides per view and no effect
  const swiper = new Swiper(container, {
    slidesPerView: 1.05,
    spaceBetween: 20,
    loop: false,
    freeMode: true,
    allowTouchMove: true,
    breakpoints: {
        1080: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        768: {
            slidesPerView: 2.5,
            spaceBetween: 24,
        },
        500: {
            slidesPerView: 1.2,
            spaceBetween: 24,
        },
    },
  });
});